import React from "react";
import ReactDOM from "react-dom";

export const render = ({
  children,
  elementId,
}: {
  children: React.ReactElement;
  elementId: string;
}) => {
  const element = document.getElementById(elementId);
  if (!element) {
    throw new Error(`could not find element with id ${elementId}`);
  }
  ReactDOM.render(
    <React.StrictMode>{children}</React.StrictMode>,
    document.getElementById(elementId)
  );
};
